import React, {useCallback} from 'react';
import {Button, Text} from '@albert-io/atomic';
import {GradeLevelModelV1} from '@albert-io/models';
import {upperFirst} from 'lib/stringUtils';

import './grade-selector.scss';

interface GradeSelectorProps {
  selectedGradeLevels: GradeLevelModelV1[];
  setSelectedGradeLevels: (selectedGradeLevels: GradeLevelModelV1[]) => void;
  allGradeLevels: GradeLevelModelV1[];
  errorMessage?: string | null;
}

const GradeSelector = ({
  setSelectedGradeLevels,
  selectedGradeLevels,
  allGradeLevels,
  errorMessage
}: GradeSelectorProps) => {
  const handleSelectGradeLevel = useCallback(
    (gradeLevel: GradeLevelModelV1) => {
      if (selectedGradeLevels.some((level) => level.getId() === gradeLevel.getId())) {
        setSelectedGradeLevels(
          selectedGradeLevels.filter((level) => level.getId() !== gradeLevel.getId())
        );
      } else {
        setSelectedGradeLevels([...selectedGradeLevels, gradeLevel]);
      }
    },
    [selectedGradeLevels, setSelectedGradeLevels]
  );

  return (
    <div className='u-mar-tb_4'>
      <Text as='div'>Grade Levels</Text>
      <Text as='p' color='tertiary' size='s' className='u-mar-b_2'>
        Select at least one...
      </Text>
      <div className='grade-selector__container u-mar-b_2'>
        {allGradeLevels.map((gradeLevel) => {
          const gradeLevelString = gradeLevel.getGradeLevelType();
          const isSelected = selectedGradeLevels.some(
            (gLevel) => gLevel.getId() === gradeLevel.getId()
          );
          return (
            <Button
              className='grade-selector__button'
              key={`grade-level-${gradeLevelString}`}
              data-testid={`grade-selector__grade-${gradeLevelString}-button`}
              onClick={() => handleSelectGradeLevel(gradeLevel)}
              color={isSelected ? 'primary' : 'secondary'}
              variant={isSelected ? 'solid' : 'outlined'}
              aria-label={`Select grade level: ${gradeLevelString}`}
            >
              {upperFirst(gradeLevelString)}
            </Button>
          );
        })}
      </div>
      {errorMessage && (
        <Text aria-live='assertive' color='negative'>
          {errorMessage}
        </Text>
      )}
    </div>
  );
};

export default GradeSelector;
